import React, { useMemo } from 'react';
import { Checkbox } from '@mui/material';

import { MasterSlaApiResponse } from '../../types/api/MasterSlaApiType';
import { City, MasterPrefectureApiResponse, Prefecture } from '../../types/api/MasterPrefectureApiType';
import { DeviceInfoRow, EstimateDetail } from '../../types/common/EstimateInquiryType';

import { EditEstimateRowEditTerm } from './EditEstimateRowEditTerm';
import { EditEstimateRowEditSla } from './EditEstimateRowEditSla';

type EditEstimateRowEditProps = {
    estimatePatternRowNumber: number;
    masterPrefecture: MasterPrefectureApiResponse;
    slaList: Array<MasterSlaApiResponse>;
    estimate: EstimateDetail;
    setStateEstimateDetail: (
        changeEstimateDetailData: EstimateDetail,
        changeEstimatePatternRowNumber: number
    ) => void;
    inputMode: boolean;
    deviceList: DeviceInfoRow[];
};

export const EditEstimateRowEdit: React.FC<EditEstimateRowEditProps> = ({
    estimatePatternRowNumber,
    masterPrefecture,
    slaList,
    estimate,
    setStateEstimateDetail,
    inputMode,
    deviceList,
}) => {
    // 機器対象の取得
    const deviceInfo = deviceList.find(it => it.deviceRowNumber == estimate.deviceRowNumber);
    const deviceInputInfo = deviceInfo?.inputList.find(it => it.inputRowNumber == estimate.inputRowNumber);
    // 都道府県
    const prefectureList = useMemo<Array<Prefecture>>(() => masterPrefecture.prefecture, []);
    const prefecture = prefectureList.find((e) => Number(e.prefecture_id) === Number(deviceInputInfo?.prefectureId));
    // 市
    const cityList = useMemo<Array<City>>(() => masterPrefecture.city, []);
    const city = cityList.find((e) => Number(e.city_id) === Number(deviceInputInfo?.cityId));

    // 行ID キー：見積NO＋機器行No＋機器編集行No
    const rowID = `${estimatePatternRowNumber}-${estimate.deviceRowNumber}-${estimate.inputRowNumber}`;

    return (
        <>
            <div>
                <div className='check-box-area'>
                    <div className='device-check-area'>
                        <Checkbox
                            id={`device-checkitem-${rowID}`}
                            onChange={(event) =>
                                setStateEstimateDetail(
                                    {
                                        ...estimate,
                                        checkFlag: event.target.checked,
                                    },
                                    estimatePatternRowNumber
                                )
                            }
                            checked={estimate.checkFlag}
                            disabled={!inputMode}
                        />
                    </div>
                    <div className='device-content-area'>
                        <label htmlFor={`device-checkitem-${rowID}`}>
                            <div className='device-content'>
                                <div className='device-title'>
                                    <h2>{deviceInfo?.makerName}</h2>
                                    <h2>{deviceInfo?.modelName ? deviceInfo?.modelName : deviceInfo?.searchWord}</h2>
                                    <h2>{prefecture ? prefecture.prefecture_name : ''}</h2>
                                    <h2>{city ? city.city_name : ''}</h2>
                                    <h2>{deviceInputInfo?.unitCount}台</h2>
                                    <p className='freeText' title={deviceInputInfo?.freeText}>
                                        {deviceInputInfo?.freeText}
                                    </p>
                                </div>
                                <div className='device-content-edit-area'>
                                    <EditEstimateRowEditTerm
                                        estimatePatternRowNumber={estimatePatternRowNumber}
                                        estimate={estimate}
                                        setStateEstimateDetail={setStateEstimateDetail}
                                        inputMode={inputMode}
                                    />
                                    <EditEstimateRowEditSla
                                        rowID={rowID}
                                        estimatePatternRowNumber={estimatePatternRowNumber}
                                        masterSla={slaList}
                                        estimate={estimate}
                                        setStateEstimateDetail={setStateEstimateDetail}
                                        inputMode={inputMode}
                                    />
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
};
